import React from 'react'
import HeaderImage from '../assets/executive.png'
import Navigation from '../navbar'
import Judith from '../assets/leadership/judith.png'
import Footer from '../footer'
import { useNavigate } from 'react-router-dom';


function Leadership() {
  let navigate = useNavigate();

  const Management = () => {
    navigate("/leadership")
  }

  return (

    <>

      <Navigation />

      <div className="relative">
        <div className="absolute inset-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
          src={HeaderImage}
          alt="Ghana Gas GPP"
        />
      </div>

      <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10 phone:hidden md:block  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px] hover:cursor-pointer" onClick={Management}>
        Executive Management
      </h1>

      <div class="grid md:grid-cols-3 phone:grid-cols-2 gap-4">
        <div class="col-span-1 flex items-start justify-end">
          <img src={Judith} alt="CEO Image" className='scale-75' />
        </div>
        <div class="col-span-2 flex items-center">
          <div>
            <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Ms Judith Adjobah Blay</p>
            <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10"> Chief Executive Officer</p>
            <br/>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
            Ms Judith Adjobah Blay has over two decades of distinguished experience in Ghana’s energy sector and beyond. She is widely recognised for her strategic leadership, policy development expertise, and commitment to sustainable business practices.</p>  <br/>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
            Throughout her career, Ms Blay has successfully managed multi-million-dollar projects, strengthened regulatory compliance, and championed local content development. Her leadership has consistently driven operational excellence, fostered stakeholder engagement, and improved governance across several critical roles.</p>  <br/>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
            Prior to her appointment as CEO of Ghana Gas, Ms Blay served as Deputy Director of Contracts Administration at the Petroleum Commission Ghana and previously managed Community Relations at the Commission. She also established and led the Procurement Department at Bui Power Authority and served as Project Coordinator on the MCC Compact II at the Ministry of Energy/USAID. </p>  <br/>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
            She is a Chartered Member of the Chartered Institute of Procurement & Supply (CIPS-UK), holds an MA in International Transactions from George Mason University, USA, and an MSc in Procurement & Supply Chain Management from KNUST. In addition, she holds a BA in French and Linguistics from the University of Ghana and is currently pursuing an LLM in Public Procurement Law & Policy at the University of Nottingham.</p>  <br/>
          </div>
        </div>
      </div>
<br/>

      <Footer />
    </>
  )

}

export default Leadership;